import DAYS from '@anm/constants/days';
import { FC } from 'react';

import DateContainer from './DateContainer';
import { DatesTableWrapper, DatesWrapper, DaysWrapper, DayCell, TableLabel } from './Wrapper';
import { getTableLabel } from './helpers';
import { useDates } from './hooks';
import { DatesTableProps } from './types';

const DatesTable: FC<DatesTableProps> = ({
  isRangeDate,
  selectedDates,
  currentViewDate,
  disableDates,
  onDateChange
}) => {
  const dates = useDates(currentViewDate);

  return (
    <DatesTableWrapper>
      <TableLabel>{getTableLabel(currentViewDate)}</TableLabel>
      <DaysWrapper>
        {DAYS.map(day => (
          <DayCell key={day}>{day.slice(0, 3)}</DayCell>
        ))}
      </DaysWrapper>
      {dates && (
        <DatesWrapper>
          {dates.map((date, index) => (
            <DateContainer
              key={index}
              {...{
                date,
                isRangeDate,
                onDateChange,
                selectedDates,
                currentViewDate,
                disableDates
              }}
            >
              {date}
            </DateContainer>
          ))}
        </DatesWrapper>
      )}
    </DatesTableWrapper>
  );
};

export default DatesTable;
